// expects product to be in form of GoogleTagManagerProductFieldObject
// TODO: Remove old GA
export const addToCartOld = function (quantity, product) {
    window.dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
            'currencyCode': currencyCodeFromProduct(product),
            'add': {
                'products': [{
                    'name': product.name || product.Name,
                    'id': product.id || product.Id,
                    'price': product.price || product.Price,
                    'brand': product.brand || product.Brand,
                    'category': product.category || product.Category,
                    'quantity': quantity,
                    'variant': product.variant || product.Variant
                }]
            }
        }
    });
}

// expects product to be in form of GoogleTagManagerProductFieldObject
export const addToCart = function (quantity, product) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            currency: currencyCodeFromProduct(product),
            value: valueFromProduct(product, quantity),
            items: [{
                item_id: product.id || product.Id,
                item_name: product.name || product.Name,
                item_brand: product.brand || product.Brand,
                item_category: product.category || product.Category,
                item_variant: product.variant || product.Variant,
                price: product.price || product.Price,
                quantity: quantity,
            }]
        }
    }); 
}

// expects product to be in form of GoogleTagManagerProductFieldObject[]
export const bulkAddToCart = function (products) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            currency: currencyCodeFromProduct(products[0]),
            value: valueFromBulkProduct(products),
            items: products.map((product) => ({
                item_id: product.id || product.Id,
                item_name: product.name || product.Name,
                item_brand: product.brand || product.Brand,
                item_category: product.category || product.Category,
                item_variant: product.variant || product.Variant,
                price: product.price || product.Price,
                quantity: product.quantity || product.Quantity,
             }))
        }
    });
}

// expects product to be in form of GoogleTagManagerProductFieldObject
// TODO: Remove old GA
export const removeFromShoppingCartOld = function (quantity, product) {
    window.dataLayer.push({
        'event': 'removeFromCart',
        'ecommerce': {
            'currencyCode': currencyCodeFromProduct(product),
            'remove': {
                'products': [{
                    'name': product.name || product.Name,
                    'id': product.id || product.Id,
                    'price': product.price || product.Price,
                    'brand': product.brand || product.Brand,
                    'category': product.category || product.Category,
                    'variant': product.variant || product.Variant,
                    'quantity': quantity
                }]
            }
        }
    });
}

// expects product to be in form of GoogleTagManagerProductFieldObject
export const removeFromShoppingCart = function (quantity, product) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
            currency: currencyCodeFromProduct(product),
            value: valueFromProduct(product, quantity),
            items: [{
                item_id: product.id || product.id,
                item_name: product.name || product.Name,
                item_brand: product.brand || product.Brand,
                item_category: product.category || product.Category,
                item_variant: product.variant || product.Variant,
                price: product.price || product.Price,
                quantity: quantity,
            }]
        }
    });
}

// expects product to be in form of GoogleTagManagerProductFieldObject
// TODO: Remove old GA
export const productDetail = function (products) {
    window.dataLayer.push({
        'ecommerce': {
            'currencyCode': currencyCodeFromProduct(products[0]),
            'detail': {
                'products': products.map((product) => ({
                    'name': product.name || product.Name, // Must be name, not display name
                    'id': product.id || product.Id,
                    'price': product.price || product.Price,
                    'brand': product.brand || product.Brand,
                    'category': product.category || product.Category,
                    'variant': product.variant || product.Variant,
                })
                )
            }
        }
    });
}

// expects product to be in form of GoogleTagManagerProductFieldObject
//
// The search term is the search string for search pages, and empty for other lists.
export const viewItemList = function (products, listName, searchTerm, startingItemIndex = 0, pageSize = products.length) {
    if (!products || !products.length) return;
    
    (async () => {
        const isSidewideDlExist = await waitForDataLayer();

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                item_list_name: listName,
                item_list_search_term: searchTerm,
                items: products.slice(startingItemIndex, startingItemIndex + pageSize).map((product, i) => ({
                    item_name: product.name || product.Name,
                    item_id: product.id || product.Id,
                    price: product.price || product.Price,
                    item_brand: product.brand || product.Brand,
                    item_category: product.category || product.Category,
                    item_variant: product.variant || product.Variant,
                    index: (startingItemIndex + i),
                    item_list_name: product.item_list_name,
                    item_list_id: product.item_list_id, 
                })
                )
            }
        });
        storeIntoLocalStorage(products);
    })();
}

export const viewItemListFeaturedProducts = function (products, listName) {
    if (!products || !products.length) return;
 
    (async () => {
        const isSidewideDlExist = await waitForDataLayer();

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                item_list_name: listName,
                item_list_search_term: "",
                items: products.map((product) => ({
                    item_name: product.name || product.Name,
                    item_id: product.id || product.Id,
                    price: product.price || product.Price,
                    item_brand: product.brand || product.Brand,
                    item_category: product.category || product.Category,
                    item_variant: product.variant || product.Variant,
                    index: product.Index || product.index,
                    item_list_name: product.item_list_name,
                    item_list_id: product.item_list_id,
                })
                )
            }
        });
        storeIntoLocalStorage(products, (listName == "pdp_related") ? listName: "")
    })();
}

const storeIntoLocalStorage = (products, listName = "") => {
    window.localStorage.setItem("view_item_list" + listName, JSON.stringify(products));
}

export const waitForDataLayer = () => {
    let maxAttempt = 3;
    return new Promise((resolve, reject) => {
        const check = () => {
            if (window.dataLayer && Array.isArray(window.dataLayer) && window.dataLayer.find(el => el["event"] == "sitewide_dl")) {
                resolve(true);
            } else {
                setTimeout(check, 300);
            }
        };
        if (maxAttempt > 0) {
            maxAttempt--;
            check();
        } else {
            //Reached maximum attempt.
            reject(false);
        }
    });
};

// expects product to be in form of GoogleTagManagerProductFieldObject
export const productClick = function (product, list, position) {
    window.dataLayer.push({
        'event': 'productClick',
        'currencyCode': currencyCodeFromProduct(product),
        'ecommerce': {
            'click': {
                'actionField': { 'list': list },
                'products': [{
                    'name': product.name || product.Name,
                    'id': product.id || product.Id,
                    'price': product.price || product.Price,
                    'brand': product.brand || product.Brand,
                    'category': product.category || product.Category,
                    'variant': product.variant || product.Variant,
                    'position': position
                }]
            }
        }
    });
}

// expects product to be in form of GoogleTagManagerProductFieldObject
export const viewProduct = function (products) {
    (async () => {
        const isSidewideDlExist = await waitForDataLayer();
        var product = products[0];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'view_item',
            ecommerce: {
                currency: currencyCodeFromProduct(product),
                value: valueFromProduct(product, 1),
                items: [{
                    item_id: product.id || product.Id,
                    item_name: product.name || product.Name,
                    item_brand: product.brand || product.Brand,
                    item_category: product.category || product.Category,
                    item_variant: product.variant || product.Variant,
                    price: product.price || product.Price,
                    quantity: 1,
                }]
            }
        });
    })();
}

const currencyCodeFromProduct = (product) => product.currencyCode ? product.currencyCode : product.CurrencyCode;

const valueFromProduct = (product, quantity) =>  {
    var price = product.Price || product.price;
    return price > 0 ? parseInt(quantity) * price : 0;
}

const valueFromBulkProduct = (products) => {
    let totPrice = 0;
    products.forEach(function (product) {
        var price = product.Price || product.price;
        var qty = product.Quantity || product.quantity;
        totPrice = totPrice + (price > 0 ? parseInt(qty) * price : 0);
    });

    return totPrice;
}

export const addtoDataLayerLoginClick = (type) => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'loginClickType': type, // value will be header, product detail page, mini cart, cart
        'event': 'login_click'
    });
}

export const pushProductRecommendations = (carouselEl) => {
    let block = findParentByClassName(carouselEl, 'jsCarouselProducts')
    let viewItems = [];
    let visibleItems = [];
        const item_list_name = block.dataset.pageName;
        const item_list_id = block.dataset.itemListId;
        let carouselContainer = block.querySelector('.flickity-viewport');
        const carouselItems = Array.from(carouselContainer.querySelectorAll('.carousel__item'));
        let indexArray = [];
        function updateActiveItems() {
           
            const targetIndex = carouselItems.findIndex(item => item.classList.contains('is-selected'));
            
            if (window.innerWidth < 992) {
                visibleItems.push(carouselItems[targetIndex]);
                indexArray.push(targetIndex);
            } else {
                const l = carouselItems.length;
                const r = l - targetIndex;
                if (r > 4) {
                    const max = targetIndex + 4;
                    visibleItems = carouselItems.slice(targetIndex, max);
                    for (let i = targetIndex; i < max; i++ ) {
                        indexArray.push(i);
                    }

                } else if (r <= 4) {
                    let max = targetIndex + r;
                    visibleItems = carouselItems.slice(targetIndex, max);
                    for (let i = targetIndex; i < max; i++) {
                        indexArray.push(i);
                    }
                    max = 4 - r;
                    if (max > 0) {
                        const remainValus = carouselItems.slice(0, max);
                        remainValus.forEach(val => { visibleItems.push(val); })
                        for (let i = 0; i < max; i++) {
                            indexArray.push(i);
                        }
                    }
                }
            }
            visibleItems.forEach((item, i) => {
                const json = item.querySelectorAll('.js-product-tile')[0].dataset.ga4Tracking;
                if (json != null) {
                    let jsonData = JSON.parse(json);
                    viewItems.push({
                        ...jsonData,
                        index: indexArray[i],
                        item_list_name: item_list_name,
                        item_list_id: item_list_id
                    });
                }
            });
            

            // Get up to 4 elements after the target element
            viewItemListFeaturedProducts(viewItems, item_list_name);
        }
        updateActiveItems(); // Initial check
    
}

export const findParentByClassName = (element, className) => {
    let currentElement = element;

    while (currentElement) {
        if (currentElement.classList && currentElement.classList.contains(className)) {
            return currentElement;
        }
        currentElement = currentElement.parentElement;
    }

    return null; // Return null if no parent element with the class name is found
}

const carouselNavButton = (event) => {
    pushProductRecommendations(event.target);
}
document.addEventListener("DOMContentLoaded", function () {
    const carouselElList = document.querySelectorAll(".carousel--featured-products");
    carouselElList.forEach(carouselEl => { 
        let counter = 3;
        function checkCarouselInitialization() {
            counter--;
            // Get the carousel instance
            const carousel = carouselEl.querySelector('.flickity-viewport');

            if (carousel) {
                carouselEl.querySelectorAll(".flickity-prev-next-button").forEach(navBtn => {
                    navBtn.addEventListener('click', carouselNavButton);
                });
                pushProductRecommendations(carouselEl);

            } else if (counter > 0) {
                // Retry after a short delay if needed
                setTimeout(checkCarouselInitialization, 300);
            }
        }
        checkCarouselInitialization();
    });
});